import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/4.mp3"
export default function P1() {
    return (
        <MainLayout
        title="Studnia"     
        question="Którą drogę do miasteczka wybierzesz?" 
            audio={audio}
        answers={{
            ans1: "Szutrową drogę.",
            ans2: "Ścieżkę pod lasem.",    
        }}
        links={{
            link1: PAGES.p5,
            link2: PAGES.p6,
        }}
        content={
            <div>
                <p>
                Podchodzisz do studni i zaczynasz powoli kręcić korbą. Łańcuch jest trochę zardzewiały. Zza studni słychać trzaśnięcie gałązki.
                </p>
                <ul>
                    <li>Jest tam kto? – pytasz, obchodząc studnię.</li>
                    <li>Cicho! – syczy mały chłopiec schowany za deskami.</li>
                    <li>A co ty tam robisz?</li>
                    <li>Chowam się. Idź stąd!</li>
                    <li>Przed kim?</li>
                    <li>Przed Gucią. Nie stój tu! Zobaczy, że ze mną rozmawiasz!</li>
                </ul>
                <p>
                W kopie siana widzisz drugiego chłopca, a daleko na polu szukającą go dziewczynkę. Pytasz chłopca, gdzie możesz znaleźć nocleg i jakiś zarobek.
                </p>
                <ul>
                    <li>
                    Uch… Idź spytaj kantora. Tam! – pokazuje w stronę miasteczka.
                    </li>
                </ul>
                <p>
                Zanim zdążysz podziękować, mały zakopuje się w deskach. Czas ruszać. Tylko którędy? Szutrowa droga prowadzi prosto do miasteczka, ale od strony krętej ścieżki wzdłuż świerkowego lasu słychać dziwne odgłosy. 
                </p>
            </div>
        }
        />
        
            );
}